import React from 'react';
import {Dimensions, Platform, View} from 'react-native';
import {NavigationProp, useNavigation} from '@react-navigation/native';
import {Card, Image, makeStyles} from '@rneui/themed';
import {observer} from 'mobx-react';

import onLight from '../../../images/brand/rewards/on-light.png';
import {AppRoute} from '../../../models/AppRoute';
import {useStores} from '../../../stores/use-stores';
import {OffersItemWithMflId} from '../../../transport/types';
import Text from '../../themed/Text';
import PressableWithOpacityFeedback from '../../ui-controls/PressableWithOpacityFeedback';

const ExclusiveOffersTileCompact = observer((offer: OffersItemWithMflId) => {
  const styles = useStyles();
  const navigation = useNavigation<NavigationProp<any>>();
  const {cartStore} = useStores();

  const isApplied = cartStore.activatedDeals.includes(offer?.mflId);

  return (
    <PressableWithOpacityFeedback
      onPress={() => {
        if (offer.mflId) {
          navigation.navigate(AppRoute.EXCLUSIVE_OFFER_DETAIL, {
            mflId: offer?.mflId,
          });
        }
      }}>
      <Card
        noMargin
        applied={isApplied}
        variant={'button2'}
        containerStyle={{
          height: 203,
          maxWidth: 270,
          width: Dimensions.get('window').width - 30,
        }}
        wrapperStyle={{
          gap: 12,
        }}>
        <View style={{flexDirection: 'row', alignItems: 'center', gap: 8}}>
          <Image source={onLight} style={{width: 50, height: 36}} />
          <Text style={styles.title}>{offer.tileHeadline}</Text>
        </View>
        <Text style={styles.subtitle}>{offer.headline}</Text>
        <Card.Divider
          style={{
            marginBottom: 0,
            borderStyle: Platform.select({web: 'dashed'}),
          }}
        />
        <Text style={styles.description} numberOfLines={2}>
          {offer.description}
        </Text>
        <Text
          style={[styles.apply, isApplied && styles.applied]}
          variant="heading3">
          {isApplied ? 'APPLIED' : 'APPLY'}
        </Text>
      </Card>
    </PressableWithOpacityFeedback>
  );
});

const useStyles = makeStyles(theme => {
  return {
    title: {
      fontSize: 14,
      fontWeight: 'bold',
    },
    subtitle: {
      fontSize: 14,
      fontWeight: '600',
      color: theme.colors.black,
    },
    description: {
      fontSize: 14,
      fontWeight: '600',
      color: theme.colors.grey2,
    },
    apply: {
      textAlign: 'right',
    },
    applied: {
      color: theme.colors.black,
    },
  };
});

export default ExclusiveOffersTileCompact;
